import Layout from "@components/Layout";
import RadioInputButton from "@components/RadioInputButton";
import { useTranslation } from "react-i18next";
import { Form, useSubmit } from "react-router-dom";

export default function LearningPage() {
  const submit = useSubmit();
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form);
  };

  return (
    <Layout>
      <div className="flex h-full flex-col">
        <div className="shrink-0">
          <h1 className="heading">{t("pages.onboarding.learning.heading")}</h1>
        </div>

        <Form
          className="flex grow flex-col justify-center space-y-5"
          method="post"
        >
          <RadioInputButton
            className=""
            label={t("pages.onboarding.learning.realWorldCaseStudies")}
            name="learning"
            onChange={handleChange}
            value="real-world-case-studies"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.learning.theoreticalInsights")}
            name="learning"
            onChange={handleChange}
            value="theoretical-insights"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.learning.stepByStepGuides")}
            name="learning"
            onChange={handleChange}
            value="step-by-step-guides"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.learning.inspirationalStories")}
            name="learning"
            onChange={handleChange}
            value="inspirational-stories"
          />
        </Form>
      </div>
    </Layout>
  );
}
